import React, { useEffect, useState, useCallback } from 'react'
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Card, Container, Row, Col, Modal, Button, Table } from 'react-bootstrap';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { GiftFill } from 'react-bootstrap-icons'
import Swal from 'sweetalert2';

const formatoNumero = new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 0
});


const PremioDestacado = ({ premio, puntos, onCanjearClick }) => {
    const porcentaje = Math.min((puntos / premio.puntos) * 100, 100);
    return (
        <div className="premio-destacado"
            style={{
                minWidth: '300px',
                background: 'linear-gradient(145deg, #1a1a1a, #2d2d2d)',
                borderRadius: '15px',
                padding: '20px',
                position: 'relative',
                overflow: 'hidden'
            }}>
            <div className="text-center">
                <img
                    src={premio.imagen}
                    alt={premio.nombre}
                    style={{
                        height: '180px',
                        objectFit: 'contain',
                        marginBottom: '15px'
                    }}
                />
                <div style={{ height: '100px' }}>
                    <h3 className="text-warning">{premio.nombre}</h3>
                </div>
                <div className="progress-container">
                    <div className="d-flex justify-content-between mb-2">
                        <span className="text-white-50">Tus puntos: {formatoNumero.format(puntos)}</span>
                        <span className="text-warning">Meta: {formatoNumero.format(premio.puntos)}</span>
                    </div>
                    <div className="progress" style={{ height: '8px' }}>
                        <div
                            className="progress-bar bg-warning"
                            style={{ width: `${porcentaje}%` }}
                        />
                    </div>
                </div>
                <p className="text-white-50 mb-4">{premio.descripcion}</p>
                <Button
                    className="w-100"
                    variant={puntos < premio.puntos || premio.disponibilidad <= 0 ? 'outline-warning' : 'warning'}
                    disabled={puntos < premio.puntos || premio.disponibilidad <= 0}
                    onClick={() => onCanjearClick(premio)}
                >{premio.disponibilidad > 0 ?
                    puntos >= premio.puntos ? '¡Canjear Ahora!' : `Te faltan ${formatoNumero.format(premio.puntos - puntos)} puntos`
                    : 'No disponible'
                    }
                </Button>
            </div>
        </div>
    );
};

const PremioCard = ({ premio, puntos, onCanjearClick }) => (
    <Card className="h-100 border-0 rounded-4 overflow-hidden"
        style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            width: '230px',
            margin: '0 auto'
        }}
    >
        <div className="position-relative">
            {premio.destacado === 1 && (
                <div className="position-absolute top-0 start-0 m-2">
                    <span className="badge bg-warning text-dark p-2">
                        DESTACADO
                    </span>
                </div>
            )}
            <Card.Img
                className='mt-2'
                src={premio.imagen}
                alt={premio.nombre}
                style={{ height: '200px' }}
            />
        </div>
        <Card.Body className="d-flex flex-column text-center">
            <Card.Title className="fw-bold mb-1 text-dark text-uppercase w-100" style={{ fontSize: '1.3rem' }}>
                {premio.nombre}
            </Card.Title>
            <div className="mb-2">
                <h3 className="text-warning fw-bold mb-0" style={{ fontSize: '2.5rem' }}>
                    {formatoNumero.format(premio.puntos)}
                </h3>
                <small className="text-warning">puntos</small>
            </div>
            {premio.disponibilidad > 0 ? (
                <p className="text-dark mb-2" style={{ fontSize: '1.1rem' }}>
                    Disponible: {premio.disponibilidad}
                </p>
            ) : (
                <p className="text-danger mb-2" style={{ fontSize: '1.1rem' }}>
                    No disponible
                </p>
            )}
            <Card.Text className="h-25 flex-grow-1 text-muted">
                {premio.descripcion}
            </Card.Text>
            <div className="d-flex justify-content-center">
                <Button
                    variant={premio.disponibilidad <= 0 || puntos < premio.puntos ? 'outline-secondary' : 'outline-warning'}
                    className="rounded-pill w-90"
                    disabled={premio.disponibilidad <= 0 || puntos < premio.puntos}
                    onClick={() => onCanjearClick(premio)}
                    style={{
                        width: '90%',
                        fontSize: '0.8rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                    }}
                >{premio.disponibilidad > 0 ?
                    puntos >= premio.puntos ? '¡Canjear Ahora!' : `Te faltan ${formatoNumero.format(premio.puntos - puntos)} puntos`
                    : 'No disponible'
                    }
                </Button>
            </div>
        </Card.Body>
    </Card>
);

const ModalConfirmacion = ({ show, onHide, premio, puntos, error, onConfirm }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
            <Modal.Title>Confirmar Redención</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {premio && (
                <>
                    <p>¿Estás seguro que deseas canjear tus puntos en este premio?</p>
                    <div className="text-center mb-3">
                        <img
                            src={premio.imagen}
                            alt={premio.nombre}
                            style={{ maxHeight: '200px', objectFit: 'contain' }}
                        />
                    </div>
                    <h4 className="text-center">{premio.nombre}</h4>
                    <p className="text-center">
                        Costo: <strong>{formatoNumero.format(premio.puntos)} puntos</strong>
                    </p>
                    <p className="text-center">
                        Tus puntos disponibles: <strong>{formatoNumero.format(puntos)}</strong>
                    </p>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                </>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
                Cancelar
            </Button>
            <Button
                variant="warning"
                onClick={() => onConfirm(premio)}
                disabled={!premio || puntos < premio.puntos}
            >
                Confirmar Canje
            </Button>
        </Modal.Footer>
    </Modal>
);

const ModalPremiosRedimidos = ({ show, onHide, loading, premiosRedimidos }) => (
    <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
            <Modal.Title>Mis Premios Redimidos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {loading ? (
                <div className="text-center p-4">
                    <div className="spinner-border text-warning" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                </div>
            ) : premiosRedimidos.length === 0 ? (
                <div className="text-center p-4">
                    <p className="mb-0">No tienes premios redimidos aún.</p>
                </div>
            ) : (
                <div className="table-responsive">
                    <Table hover>
                        <thead>
                            <tr>
                                <th>Premio</th>
                                <th>Descripción</th>
                                <th>Fecha</th>
                                <th>Estado Entrega</th>
                                <th>Puntos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {premiosRedimidos.map((premio) => (
                                <tr key={premio.id_puntos_cliente}>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={premio.imagen}
                                                alt={premio.nombre}
                                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '10px' }}
                                            />
                                        </div>
                                    </td>
                                    <td><span>{premio.nombre}</span></td>
                                    <td>{new Date(premio.fecha_movimiento).toLocaleDateString()}</td>
                                    <td>
                                        <span className={`py-2 px-4 rounded-2 fw-bold ${premio.estado_entrega === 'ENTREGADO' ? 'bg-success' : 'bg-warning'}`}>
                                            {premio.estado_entrega}
                                        </span>
                                    </td>
                                    <td>{formatoNumero.format(Math.abs(premio.puntos))}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
                Cerrar
            </Button>
        </Modal.Footer>
    </Modal>
);

const CatalogoPuntos = () => {
    const navigate = useNavigate();
    const urlFtp = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/';
    const urlBackend = `${process.env.REACT_APP_SERVER}/api/v1`;
    const [premios, setPremios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [puntos, setPuntos] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedPremio, setSelectedPremio] = useState(null);
    const [error, setError] = useState(null);
    const [showModalRedimidos, setShowModalRedimidos] = useState(false);
    const [premiosRedimidos, setPremiosRedimidos] = useState([]);

    const verificarAcceso = useCallback(async () => {
        const urlFtpPremios = process.env.REACT_APP_SERVER_IMAGE + 'premios/';
        try {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');
            const response = await axios.get(`${urlBackend}/validarListaPrecio`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            if (response.data.lista_de_precios !== '001') {
                navigate('/catalogo');
                return;
            }
            const premiosResponse = await axios.get(`${urlBackend}/premios`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            if (premiosResponse.data.result) {
                const premiosConImagen = premiosResponse.data.premios.map(premio => ({
                    ...premio,
                    imagen: urlFtpPremios + premio.imagen
                }));
                setPremios(premiosConImagen);
            }
            const urlPuntos = `${urlBackend}/customers/puntos/client`;
            const resultPuntos = await axios.post(urlPuntos, response.data, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            if (resultPuntos.data[0].puntos_positivos !== null) {
                setPuntos(parseInt(resultPuntos.data[0].puntos_positivos) + parseInt(resultPuntos.data[0].puntos_negativos));
                cookies.set('puntos', parseInt(resultPuntos.data[0].puntos_positivos) + parseInt(resultPuntos.data[0].puntos_negativos));
            }
        } catch (error) {
            console.error('Error al verificar acceso:', error);
            navigate('/catalogo');
        } finally {
            setLoading(false);
        }
    }, [navigate, urlBackend]);

    const handleVerMisPremiosRedimidos = useCallback(async () => {
        const urlFtpPremios = process.env.REACT_APP_SERVER_IMAGE + 'premios/';
        try {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');
            const response = await axios.get(`${urlBackend}/premios/redimidos`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            if (response.data.result) {
                const premiosConImagen = response.data.premios.map(premio => ({
                    ...premio,
                    imagen: urlFtpPremios + premio.imagen
                }));
                setPremiosRedimidos(premiosConImagen);
                setShowModalRedimidos(true);
            }
        } catch (error) {
            console.error('Error al obtener premios redimidos:', error);
            setError(error.response?.data?.message || 'Error al obtener premios redimidos');
        }
    }, [urlBackend]);

    const handleRedimirPremio = async (premio) => {
        try {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');
            const body = {
                id_premio: premio.id,
                puntos_premio: premio.puntos
            };
            const response = await axios.post(`${urlBackend}/premios/redimir/`, body, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            if (response.data.result) {
                setShowModal(false);
                Swal.fire({
                    title: '¡Felicidades!',
                    text: 'Has redimido tu premio exitosamente',
                    icon: 'success',
                    confirmButtonText: 'Genial!',
                    confirmButtonColor: '#ffc107'
                }).then(() => {
                    window.location.reload();
                });
            }
        } catch (error) {
            console.error('Error al redimir premio:', error);
            setError(error.response?.data?.message || 'Error al redimir el premio');
        }
    };

    const handleCanjearClick = (premio) => {
        setSelectedPremio(premio);
        setShowModal(true);
    };

    useEffect(() => {
        verificarAcceso();
    }, [verificarAcceso]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-warning" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <Header />
            <Container fluid className="containerProductos">
                <br></br>
                <Container fluid="xxl" className='containerCatalogo'>
                    <h1 className="tituloCategoria segundoTitulo text-center mb-4 display-1">Catalogo de Premios</h1>
                    <Container>
                        <Row className="align-items-center mb-4">
                            <Col md={6} className="text-center">
                                <Button
                                    variant="dark"
                                    size="lg"
                                    className="p-4 w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                                    <h3 className="text-white mb-2">Tus Puntos Disponibles</h3>
                                    <h1 className="display-3 text-warning fw-bold">{formatoNumero.format(puntos)}</h1>
                                </Button>
                            </Col>
                            <Col md={6} className="text-center">
                                <Button
                                    variant="warning"
                                    size="lg"
                                    className="p-4 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                                    onClick={handleVerMisPremiosRedimidos}
                                >
                                    <GiftFill size={40} className="mb-3" />
                                    <h3 className="mb-0">Ver Mis Premios Redimidos</h3>
                                    <p className="mb-0 text-center">Consulta el estado de tus premios</p>
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                    {premios.filter(premio => premio.destacado === 1).length > 0 &&
                        <Container>
                            <h2 className="tituloCategoria segundoTitulo text-center text-white fs-1">Destacados</h2>
                            <div className="premios-destacados-container mb-2" style={{ overflowX: 'auto', padding: '20px 0' }}>
                                <div className="d-flex gap-4" style={{ minWidth: 'min-content' }}>
                                    {premios
                                        .filter(premio => premio.destacado === 1)
                                        .slice(0, 4)
                                        .map((premio) => (
                                            <PremioDestacado
                                                key={premio.id}
                                                premio={premio}
                                                puntos={puntos}
                                                onCanjearClick={handleCanjearClick}
                                            />
                                        ))}
                                </div>
                            </div>
                        </Container>
                    }
                    <Container className='containerPromocionales pb-3'>
                        <Row className="g-4 justify-content-center">
                            {premios.filter(premio => premio.destacado === 0).map((premio) => (
                                <Col key={premio.id} xs={12} sm={6} md={4} lg={3} xl={3}>
                                    <PremioCard
                                        premio={premio}
                                        puntos={puntos}
                                        onCanjearClick={handleCanjearClick}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </Container>
            </Container>
            <div>
                <img style={{ width: '100%', maxWidth: '100%' }} src={urlFtp + 'medios-pago.webp'} alt="medios de pago" />
            </div>
            <Footer />

            <ModalConfirmacion
                show={showModal}
                onHide={() => setShowModal(false)}
                premio={selectedPremio}
                puntos={puntos}
                error={error}
                onConfirm={handleRedimirPremio}
            />

            <ModalPremiosRedimidos
                show={showModalRedimidos}
                onHide={() => setShowModalRedimidos(false)}
                loading={loading}
                premiosRedimidos={premiosRedimidos}
            />
        </>
    );
};

export { CatalogoPuntos };